import { createContext, useContext, useState } from "react";

interface InsightsPanelContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const InsightsPanelContext = createContext<InsightsPanelContextType | null>(null);

export function InsightsPanelProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <InsightsPanelContext.Provider
      value={{
        isOpen,
        open: () => setIsOpen(true),
        close: () => setIsOpen(false),
      }}
    >
      {children}
    </InsightsPanelContext.Provider>
  );
}

export function useInsightsPanel() {
  const ctx = useContext(InsightsPanelContext);
  if (!ctx) throw new Error("useInsightsPanel must be inside InsightsPanelProvider");
  return ctx;
}